import resolveConfig from 'tailwindcss/resolveConfig';

const tailwindConfig = require('../../../../../config/tailwind.config');

const config = resolveConfig(tailwindConfig) as any;
const { theme } = config;
export { theme };
